/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';

@Component({
  selector: 'xrx-message',
  templateUrl: './xrx-message.component.html',
  standalone: false,
})
export class XrxMessageComponent {
  @Input() message: string;
  @Input() label: string;
}
